export const product = {
  product: "Προϊόν",
  allProducts: "Όλα τα Προϊόντα",
  myProducts: "Τα Προϊόντα μου",
  assetManagement: "Διαχείριση Προιόντων",
  addProduct: "Προσθήκη Προϊόντος",
  addEditProduct: "Προσθήκη/Επεξεργασία Προϊόντος",
  saveProduct: "Αποθήκευση Προϊόντος",
  productProperties: "Ιδιότητες Προϊόντος",
  productCategories: "Κατηγορίες Προϊόντων",
  publicName: "Δημόσιο Όνομα",
  tradeName: "Εμπορική Ονομασία",
  vat: "ΦΠΑ",
  url: "URL",
  productName: "Όνομα Προϊόντος",
  name: "Όνομα",
  description: "Περιγραφή",
  cost: "Κόστος",
  numerical: "Αριθμητικό",
  products: "Προϊόντα",
  productDetails: "Λεπτομέρειες Προϊόντος",
  manufacturer: "Κατασκευαστής",
  yearOfManufacturing: "Έτος Κατασκευής",
  uponRequest: "Κατόπιν Αιτήματος",
  priceUponRequest: "Τιμή Κατόπιν Αιτήματος",
  noProducts: "Δεν υπάρχουν προϊόντα",
  postedBy: "Αναρτήθηκε Από",
  createdAt: "Δημιουργήθηκε Στις",
  selectSubCategory: "Επιλέξτε Υποκατηγορία",
  selectExtraCategory: "Επιλέξτε Επιπλέον Κατηγορία",
  price: "Τιμή",
  isUsed: "Χρησιμοποιημένο",
  condition: "Κατάσταση",
  contactPerson: "Πρόσωπο Επικοινωνίας",
  person: "Πρόσωπο",
  contactEmail: "Email Επικοινωνίας",
  email: "Email",
  contactPhoneNumber: "Τηλέφωνο Επικοινωνίας",
  phoneNumber: "Αριθμός Τηλεφώνου",
  paymentInfo: "Πληροφορίες Πληρωμής",
  updateProduct: "Ενημέρωση Προϊόντος",
  updatedAt: "Ενημερώθηκε Στις",
  inventory: "Απόθεμα",
  quantity: "Ποσότητα",
  addInventory: "Προσθήκη Αποθέματος",
  notes: "Σημειώσεις",
  myProduct: "Το Προϊόν μου",
  addToCart: "Προσθήκη στο Καλάθι",
  createdBy: "Από",
  me: "Εγώ",
  filters: "Φίλτρα",
  filter: "Φίλτρο",
  clear: "Επαναφορά",
  details: "Λεπτομέρειες",
  withImages: "Με Εικόνες",
  author: "Συγγραφέας",
  syncWithExternalMarketplaces: "Συγχρονισμός με Εξωτερικές Αγορές",
  somethingWentWrong: "Κάτι πήγε στραβά",
  pleaseContactTheAdministrator: "Παρακαλώ επικοινωνήστε με τον διαχειριστή",
  perPage: "ανά σελίδα",
  propertyValue: "Τιμή Ιδιότητας",
  fillThePropertyFirst: "Συμπληρώστε πρώτα την ιδιότητα",
  onlyDeletesEmptyProperty: "Διαγράφει μόνο κενή ιδιότητα",
  basicInformation: "Βασικές Πληροφορίες",
  generalOrderInfo: "Γενικές Πληροφορίες Παραγγελίας",
  linePerformance: "Γραμμή παραγωγής & Επίδοση",
  all: "Όλα",
  forSale: "Προς Πώληση",
  primaryEquipment: "Κύριος Εξοπλισμός",
  secondaryEquipment: "Δευτερεύων Εξοπλισμός",
  currentOwner: "Τρέχων Κάτοχος",
  serialNumber: "Σειριακός Αριθμός",
  equipmentType: "Τύπος Εξοπλισμού",
  installationRequirements: "Απαιτήσεις Εγκατάστασης",
  processingInfo: "Πληροφορίες Επεξεργασίας",
  notForSale: "Όχι προς Πώληση",
  thirdPartyServices: "Υπηρεσίες Τρίτων",
  thirdParty: "Third Party",
  spareParts: "Ανταλλακτικά",
  incumbent: "Εν ενεργεία",
  productCapabilities: "Δυνατότητες Προϊόντος",
  equipmentCapabilities: "Δυνατότητες Εξοπλισμού",
  deleteProduct: "Διαγραφή Προϊόντος",
  deleteProductWarning:
    "Είστε σίγουρος/η ότι θέλετε να διαγράψετε αυτό το προϊόν;",
  anErrorOccurred: "Προέκυψε ένα σφάλμα",
  errorFetchingProducts: "Σφάλμα κατά την ανάκτηση των προϊόντων",
  lastRemanufacturer: "Τελευταίος Επανακατασκευαστής",
  yearOfLastRemanufacturing: "Έτος τελευταίας επανακατασκευής",
  tags: "Ετικέτες",
  tag: "Ετικέτα",
  deleteThisProduct: "Διαγράψτε αυτό το προϊόν",
  requiredWorkerSkills: "Απαιτούμενες Δεξιότητες Εργαζομένων",
  existingWorkerSkills: "Υπάρχουσες Δεξιότητες Εργαζομένων",
  workerSkills: "Δεξιότητες Εργαζομένων",
  factoryOwnerRequirements: "Απαιτήσεις Ιδιοκτήτη Εργοστασίου",
  environmentalProperties: "Περιβαλλοντικές Ιδιότητες",
  connectionCapabilities: "Δυνατότητες Σύνδεσης",
  byAuction: "Με Δημοπρασία",
  visitWebsite: "Επισκεφθείτε την Ιστοσελίδα",
  manufacturedYear: "Έτος Κατασκευής",
  dataset: "Σύνολο Δεδομένων",
  datasets: "Σύνολα Δεδομένων",
  datasetManagement: "Διαχείριση Datasets",
  allDatasets: "Όλα τα Datasets",
  myDatasets: "Τα Datasets μου",
  noDatasets: "Δεν υπάρχουν Datasets",
  datasetName: "Όνομα Dataset",
  dataType: "Τύπος Δεδομένων",
  industrySector: "Κλάδος Βιομηχανίας",
  datasetDetails: "Λεπτομέρειες Dataset",
  format: "Τύπος",
  dataCollectionMethod: "Μέθοδος Συλλογής Δεδομένων",
  associatedResearch: "Σχετική Έρευνα",
  systemicInnovation: "Συστηματική Καινοτομία",
  systemicInnovations: "Συστηματικές Καινοτομίες",
  mySystemicInnovations: "Οι Συστηματικές Καινοτομίες μου",
  associatedSystemicInnovations: "Οι Σχετιζόμενες Συστηματικές Καινοτομίες μου",
  allSystemicInnovations: "Όλες οι Συστηματικές Καινοτομίες",
  addSystemicInnovation: "Προσθήκη Συστηματικής Καινοτομίας",
  implementationLevel: "Επίπεδο Υλοποίησης",
  licenseType: "Τύπος Άδειας",
  benefits: "Οφέλη",
  addEditDataset: "Προσθήκη/Επεξεργασία Dataset",
  addEditSystemicInnovation: "Προσθήκη/Επεξεργασία Συστηματικής Καινοτομίας",
  systemicInnovationDetails: "Λεπτομέρειες Συστηματικής Καινοτομίας",
  regulatoryCompliance: "Κανονιστική Συμμόρφωση",
  competitionAnalysis: "Ανάλυση Ανταγωνισμού",
  valueProposition: "Πρόταση Αξίας",
  problemStatement: "Δήλωση Προβλήματος",
  deleteDataset: "Διαγραφή Dataset",
  contactPhone: "Τηλέφωνο Επικοινωνίας",
  shortDescription: "Σύντομη Περιγραφή",
  fullDescription: "Αναλυτική Περιγραφή",
  dataProvider: "Πάροχος Δεδομένων",
  size: "Μέγεθος",
  updateFrequency: "Συχνότητα Ενημέρωσης",
  accessLevel: "Επίπεδο Πρόσβασης",
  geographicalScope: "Γεωγραφική Εμβέλεια",
  timePeriodCovered: "Καλυπτόμενη Χρονική Περίοδος",
  variablesFeatures: "Μεταβλητές & Χαρακτηριστικά",
  compliancePlusStandards: "Συμμόρφωση & Πρότυπα",
  associatedResearchPublications: "Συναφής Έρευνα & Δημοσιεύσεις",
  pricingInfo: "Πληροφορίες Τιμολόγησης",
  contactPersonOrganization: "Υπεύθυνος Επικοινωνίας / Οργανισμός",
  lastUpdated: "Τελευταία Ενημέρωση",
  insertedByUser: "Καταχωρήθηκε από Χρήστη",
  apiUrl: "Σύνδεσμος API",
  leadingOrganizations: "Ηγετικοί Οργανισμοί",
  technologyStack: "Τεχνολογική Υποδομή",
  objectives: "Στόχοι",
  benefitsAndExpectedOutcomes: "Οφέλη & Αναμενόμενα Αποτελέσματα",
  measurableImpact: "Μετρήσιμη Επίδραση",
  pilotLocations: "Πιλοτικές Τοποθεσίες",
  caseStudies: "Μελέτες Περίπτωσης",
  regulatoryComplianceAndEthicsConsiderations:
    "Κανονιστική Συμμόρφωση & Ηθικά Ζητήματα",
  publicationsReportsAndMedia: "Δημοσιεύσεις, Αναφορές & Μέσα",
  relatedDatasets: "Σχετικά Σύνολα Δεδομένων",
  pricingModel: "Μοντέλο Τιμολόγησης",
  noSystemicInnovations: " Δεν υπάρχουν Συστηματικές Καινοτομίες",
  addDataset: "Προσθήκη Dataset",
  informationAboutBusinessModels: "Πληροφορίες για Επιχειρηματικά Μοντέλα",
  businessModels: "Επιχειρηματικά Μοντέλα",
  processingAndInstallation: "Επεξεργασία & Εγκατάσταση",
  basePlateWidth: "Πλάτος Βάσης",
  basePlateLength: "Μήκος Βάσης",
  basePlateMountingInfo: "Πληροφορίες Τοποθέτησης Βάσης",
  mountingPosition: "Θέση Τοποθέτησης",
  foundationRequirements: "Απαιτήσεις Θεμελίωσης",
  ambientTempMin: "Ελάχ. Θερμοκρασία Περιβάλλοντος",
  ambientTempMax: "Μέγ. Θερμοκρασία Περιβάλλοντος",
  pressureAirSupply: "Παροχή Πεπιεσμένου Αέρα",
  pressureAirSpecs: "Προδιαγραφές Πεπιεσμένου Αέρα",
  exhaustSystem: "Σύστημα Εξαγωγής",
  exhaustSystemSpecs: "Προδιαγραφές Συστήματος Εξαγωγής",
  powerConnection: "Σύνδεση Ρεύματος",
  powerConnectionSpecs: "Προδιαγραφές Σύνδεσης Ρεύματος",
  waterSupply: "Παροχή Νερού",
  waterSupplySpecs: "Προδιαγραφές Παροχής Νερού",
  gasSupply: "Παροχή Αερίου",
  gasSupplySpecs: "Προδιαγραφές Παροχής Αερίου",
  energyConsumption: "Κατανάλωση Ενέργειας",
};
